// extracted by mini-css-extract-plugin
export default {"headline":"yF1sA","h2":"P4eiI","desktop":"ro1W3","counterReset":"MUm1X","paragraph":"qfJss","subParagraph":"n51Bs","subSubParagraph":"fF50d"};